<template>
  <header>
    <div class="logo" @click="this.$router.go()">
      <a href="index.html">翰林永續創意教案</a>
    </div>
    <div class="menu">
      <router-link to="/">創意教案</router-link>
      <router-link to="/sdg">SDG議題分享</router-link>
      <div id="user-profile"></div>
    </div>
  </header>
  <!-- kv -->
  <section class="kv" :class="kvClass">
    <div class="title">翰林永續創意教案</div>
  </section>
</template>

<script>
export default {
  name: "HeaderComponent",
  computed: {
    kvClass() {
      const route = this.$route.path;
      if (route === '/sdg') {
        return 'kv-sdg';
      }
      return 'kv-home';
    }
  },
  mounted() {
    this.initializeUserProfile();
  },
  methods: {
    initializeUserProfile() {
      if (window.HanlinLoginWidget && window.hnalinLoginManager) {
        if (window.hnalinLoginManager.destroy) {
          window.hnalinLoginManager.destroy();
        }
      }
      
      if (window.HanlinLoginWidget) { 
        window.hnalinLoginManager = new window.HanlinLoginWidget("#user-profile", {
          authority: "https://id.hle.com.tw",
          client_id: "js",
          redirect_uri: window.location.origin + "/callback.html",
          post_logout_redirect_uri: window.location.origin + "/",
        });
      }
    }
  }
};
</script>

<style scoped></style>
